(function () {
  /**
   * @ngdoc module
   * @name app.widgets.common.feature
   * @description Module that defines feature widgets
   */
  angular.module('app.widgets.common.feature', ['binky.core.feature', 'binky.core.lodash']);
})();
